// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './Navigation.scss';

@observer class Navigation extends Component<any, any> {

	

	render() {
		return (
			<nav className="profile-edit-nav">
				<h2>profile.</h2>
				<ul>
					<li><a href="#" className={this.props.currentTab === 'changePass' ? 'active' : ''} onClick={(e) => {e.preventDefault(); this.props.changeTab('changePass')}}>Change Password</a></li>
					<li><a href="#" className={this.props.currentTab === 'changeUsername' ? 'active' : ''} onClick={(e) => {e.preventDefault(); this.props.changeTab('changeUsername')}}>Change Username</a></li>
				</ul>
			</nav>
		)
	}
}

export default Navigation;

